
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11772',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11772",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.285",
  "data-fetching-client": "static-1.9543",
  "foundations-components": "static-1.7649",
  "foundations-components-legacy": "static-1.674",
  "foundations-theming": "static-1.4278",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7874",
  "hub-http-shared-msw-handlers": "static-1.9644",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11309",
  "I18n": "static-7.1594",
  "jasmine-runner": "static-1.6336",
  "marketplace-storefront-base": "static-1.11833",
  "quartz": "static-1.6818",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16516",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2729",
  "reporting-testing-lib": "static-1.8739",
  "settings-ui-lib": "static-1.12389",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6867",
  "ui-addon-i18n": "static-1.11012",
  "ui-addon-react-router-dom": "static-1.9411",
  "unified-auth": "static-1.303",
  "unified-auth-core-lib": "static-1.584",
  "usage-tracker": "static-1.7201",
  "usage-tracker-core": "static-1.7051",
  "customer-data-property-utils": "static-1.7946",
  "history": "static-4.47",
  "hub-http": "static-1.6084",
  "integrations-lib": "static-1.15632",
  "marketplace-ui-common": "static-1.19148",
  "property-management-iframe": "static-1.12648",
  "quartz-config": "static-1.596",
  "quartz-core": "static-1.6037",
  "quartz-routing": "static-1.248",
  "quick-fetch": "static-1.3800",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4509",
  "ts-schema": "static-1.3967",
  "ui-universal-auth": "static-1.8789",
  "UIComponents": "static-3.8256",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3291",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3095",
  "quartz-webpack": "static-1.3042",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3918",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4707",
  "foundations-theming-specialty": "static-1.1994",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9292",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5237",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1404",
  "ui-fonts": "static-1.571",
  "ui-images": "static-2.1119",
  "bend-plugin-foundations-theming": "static-1.2761",
  "foundations-theming-base": "static-1.3263",
  "stylex": "static-1.28",
  "HeadJS": "static-2.728",
  "hs-test-utils-bend-plugin": "static-1.2985",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4192",
  "ai-components-ui-library": "static-1.8553",
  "ai-rendering-library": "static-1.9530",
  "chirp-fetch": "static-1.1749",
  "connections-embed-lib": "static-1.729",
  "copilot-toolkit": "static-1.10711",
  "laboratory-lib": "static-3.7025",
  "marketplace-embed": "static-1.21648",
  "marketplace-ui-details": "static-1.9044",
  "marketplace-ui-reviews": "static-1.19104",
  "marketplace-ui-tracking": "static-1.13319",
  "sanitize-text": "static-1.8011",
  "ui-addon-video-player": "static-1.8562",
  "usage-tracker-multi": "static-1.5615",
  "usage-tracker-session-replay": "static-1.4887",
  "wootric-nps": "static-1.6848",
  "apollo-link-hub-http": "static-2.4517",
  "immer": "static-1.33",
  "immerable": "static-1.4020",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2409",
  "reporting-data": "static-1.66806",
  "cssUtils": "static-1.759",
  "flux-actions": "static-1.321",
  "HubStyle": "static-2.11617",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10077",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10240",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7191",
  "icons": "static-2.635",
  "marketplace-ui-apps-core": "static-1.17681",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4386",
  "foundations-components-test-utils": "static-1.5132",
  "quartz-i18n": "static-1.493",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3596",
  "customer-data-objects": "static-1.7519",
  "property-translator": "static-1.5275",
  "frontend-preferences-client": "static-1.7790",
  "hs-promise-utils": "static-1.5459",
  "hubspot-apollo-client": "static-1.4745",
  "integrations-error-boundary-lib": "static-1.13047",
  "integrations-tracking-lib": "static-1.5456",
  "native-integrations-shared-strings": "static-1.7653",
  "reselect": "static-2.16",
  "sanitize": "static-1.4340",
  "superstore": "static-1.4635",
  "ui-shepherd-react": "static-3.10012",
  "ai-settings-ui-library": "static-1.7655",
  "hub-http-janus": "static-1.813",
  "hubspotter-http": "static-1.4540",
  "immutable-less": "static-1.4520",
  "marketplace-ui-client-types": "static-1.16555",
  "nav-meta": "static-1.29136",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10108",
  "ui-addon-upgrades": "static-9.17759",
  "inbound-db-properties-service-client": "static-1.3733",
  "property-management-common": "static-1.4936",
  "ui-addon-iframeable": "static-1.8913",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.503",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.493",
  "quartz-head": "static-1.483",
  "quartz-test": "static-1.493",
  "quartz-tracking": "static-1.197",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3022",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20619",
  "ContentUtils": "static-1.67831",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2358",
  "customer-data-filters-ui": "static-1.39150",
  "customer-data-objects-ui-components": "static-1.12879",
  "customer-data-reference-ui-components": "static-1.13015",
  "embedded-academy-lib": "static-1.13791",
  "ExportDialog": "static-6.10255",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40836",
  "reporting-snowflake": "static-1.55424",
  "reporting-ui-components": "static-2.64077",
  "reporting-visualizations": "static-1.58882",
  "ui-addon-teams": "static-1.21337",
  "magpie-lib": "static-1.5460",
  "magpie-types": "static-1.4920",
  "simple-logging-lib": "static-1.2916",
  "navigation-components": "static-1.17499",
  "ai-studio-lib": "static-1.11183",
  "app-governance-lib": "static-1.1088",
  "developer-experience-shared-components": "static-1.10368",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7857",
  "ui-product-approvals": "static-1.27679",
  "ui-tool-access": "static-1.10011",
  "usage-based-billing-components-lib": "static-1.8197",
  "usage-tracker-anonymous": "static-1.5618",
  "usage-tracker-public": "static-1.7012",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3482",
  "persist-promise": "static-1.3574",
  "reference-resolvers": "static-1.8031",
  "ui-extensibility-client-types": "static-1.3807",
  "hubspot-apollo-cache": "static-1.204",
  "universal-page-editor-lib": "static-1.2867",
  "final-form": "static-1.66",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2366",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4936",
  "purchase-motions-components": "static-1.5592",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1417",
  "crm-component-utils": "static-1.38647",
  "crm-properties-common-lib": "static-1.5739",
  "customer-data-properties": "static-1.51001",
  "framework-data-schema-resolvers": "static-1.6739",
  "property-value-citations": "static-1.1615",
  "reference-resolvers-lite": "static-1.7951",
  "navigation-messaging": "static-1.6826",
  "hubspotter-http-shared-msw-handlers": "static-1.9642",
  "cms-field-types": "static-1.4675",
  "content-icons-ui": "static-1.2183",
  "conversations-skeleton-state": "static-1.7115",
  "crm-message-bus": "static-1.42568",
  "customer-data-filters-ui-msw-helpers": "static-1.21585",
  "customer-data-ui-utilities": "static-1.9690",
  "FormUrlGenerator": "static-2.4587",
  "framework-builder-read-service-client": "static-1.3895",
  "framework-data-schema-quick-fetch": "static-1.6644",
  "multi-account-reference-resolvers": "static-1.843",
  "onboarding-tours": "static-1.16354",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13252",
  "academy-common-lib": "static-1.13251",
  "content-assistance-lib": "static-1.7541",
  "dashboard-lib": "static-1.80906",
  "file-manager-components": "static-1.23124",
  "getting-started-shared-tasks": "static-1.18069",
  "hubspot-prosemirror": "static-1.17801",
  "hubspot-prosemirror-plugins": "static-1.17793",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19588",
  "share-with-third-party-component-lib": "static-1.8559",
  "ui-addon-draggable": "static-3.4634",
  "ui-asset-management-lib": "static-1.10805",
  "ui-business-units-lib": "static-1.8899",
  "user-context": "static-1.4966",
  "growth-payments-core": "static-1.24916",
  "reporting-plugins": "static-1.10064",
  "reporting-reports": "static-1.66484",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.591",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.29007",
  "react-codemirror": "static-1.10492",
  "framework-listing-lib": "static-2.28227",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30291",
  "apps-service-types": "static-1.3743",
  "oauth-service-types": "static-1.4113",
  "onboarding-scopes": "static-1.6329",
  "onboarding-tours-client": "static-1.4568",
  "platform-infra-nav-components": "static-1.7554",
  "subscription-experience-data-types": "static-1.14673",
  "crm-record-cards-service-types": "static-1.3504",
  "location-customization-utils-lib": "static-1.8773",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4365",
  "nav-client-types": "static-1.2223",
  "purchase-motions-api": "static-1.5595",
  "signup-constants": "static-1.18544",
  "signup-ui-url-generator": "static-2.7901",
  "trials-service-types": "static-1.3766",
  "card-properties-lib": "static-1.43715",
  "commerce-subscription-lib": "static-1.36651",
  "crm-actions": "static-1.6176",
  "crm-cards-sdk": "static-1.43120",
  "customer-data-properties-shared-msw-handlers": "static-1.8971",
  "customer-data-tracking": "static-1.6748",
  "hs-entities": "static-1.553",
  "pulse": "static-1.390",
  "calling-global-api": "static-1.63935",
  "calling-internal-common": "static-1.31166",
  "calling-lifecycle-internal": "static-1.65317",
  "calling-lifecycle-messages": "static-1.57611",
  "commerce-products-lib": "static-1.9031",
  "conditional-properties-service-client": "static-1.3685",
  "crm-links": "static-1.6135",
  "external-options-client-types": "static-1.4046",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4110",
  "meetings-icalendar-utils-lib": "static-1.498",
  "multi-currency-client-types": "static-1.3577",
  "object-builder-ui-client": "static-1.48230",
  "pipeline-validation-client-types": "static-1.3851",
  "smart-property-lib": "static-1.6201",
  "tiered-pricing": "static-1.934",
  "ui-addon-form-validation": "static-1.10859",
  "crm-pipelines-api-client-types": "static-1.4027",
  "react-dnd-compat": "static-1.4486",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5225",
  "growth-onboarding-confetti": "static-1.2938",
  "growth-onboarding-next-action-utils": "static-1.1475",
  "onboarding-tours-utils": "static-1.420",
  "ui-shepherd-tracker": "static-1.7393",
  "academy-service-client": "static-1.3546",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28123",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8250",
  "video-components-external": "static-1.10786",
  "video-data-lib": "static-1.34444",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8424",
  "payment-link-components": "static-1.23115",
  "ui-addon-emoji-picker": "static-1.9753",
  "EmailSignatureEditor": "static-1.24036",
  "viral-links-lib": "static-1.6906",
  "data-token-picker": "static-1.16160",
  "FileManagerLib": "static-1.38764",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5110",
  "getting-started-shared-tasks-store": "static-1.17187",
  "campaign-roi-lib": "static-1.8483",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7188",
  "customer-data-views-management": "static-1.25125",
  "framework-data-table": "static-2.11582",
  "marketing-platform-lib": "static-1.6711",
  "nudge-client-utils": "static-1.2286",
  "nudge-custom-ui-functions": "static-1.790",
  "app-users-service-client": "static-1.5410",
  "app-users-service-types": "static-1.4818",
  "mini-checkout-client": "static-1.26478",
  "onboarding-utils": "static-1.5218",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28108",
  "edison-service-client-types": "static-1.258",
  "eligibility-engine-service-types": "static-1.3047",
  "crm_data": "static-4.91472",
  "customer-data-sidebar": "static-2.45597",
  "enrichment-properties-lib": "static-1.15319",
  "commerce-billing-lib": "static-1.18676",
  "commerce-shared-components-lib": "static-1.18135",
  "commerce-tools-ui-lib": "static-1.9969",
  "crm-fe-perf": "static-1.22770",
  "directed-graph": "static-1.805",
  "event-emitter": "static-1.813",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31172",
  "shared-worker-versioning": "static-1.10905",
  "calling-usage-tracker": "static-1.6407",
  "voice-sms-access-library": "static-1.442",
  "commerce-permissions": "static-1.629",
  "products-iframe-lib": "static-1.7519",
  "products-ui-components-shared-msw-handlers": "static-1.10026",
  "breeze-intelligence-kit": "static-1.5415",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9727",
  "policy-lib": "static-1.6644",
  "react-tinymce": "static-1.54812",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9790",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53938",
  "tinymce-plugins": "static-1.57052",
  "tinymce-themes": "static-1.55908",
  "growth-onboarding-next-action-components": "static-1.1503",
  "user-context-client": "static-1.4479",
  "growth-onboarding-feedback-components": "static-1.6447",
  "content-media-composition-data-lib": "static-1.11727",
  "content-media-compositions": "static-2.15734",
  "media-bridge-lib": "static-1.18682",
  "commerce-tours-lib": "static-1.5826",
  "growth-onboarding-reliability": "static-1.4952",
  "sales-checkout-service-client": "static-1.3534",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21426",
  "sales-email-signature-service-client": "static-1.3709",
  "audio-components": "static-1.5705",
  "FileManagerCore": "static-1.38623",
  "FileManagerImages": "static-1.36275",
  "video-components": "static-1.12789",
  "crm-export-dialog": "static-1.6160",
  "crm-index-associations-lib": "static-1.6301",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1509",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2043",
  "nudge-renderer-utils": "static-1.2362",
  "whisper-core-api": "static-1.6173",
  "InboxConnectUtils": "static-4.14402",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5207",
  "settings-content-modals": "static-1.45652",
  "crm_universal": "static-1.21762",
  "customer-data-email": "static-1.17787",
  "card-payment-highlight-lib": "static-1.36704",
  "card-subscription-highlight-lib": "static-1.39074",
  "commerce-contract-lib": "static-1.11449",
  "customer-data-content": "static-1.27002",
  "invoices-highlight-card-lib": "static-1.54240",
  "orders-highlight-card-lib": "static-1.21044",
  "products-highlight-card-lib": "static-1.17315",
  "project-storage": "static-1.4599",
  "quotes-highlight-card-lib": "static-1.71415",
  "crm-source-interpretation-lib": "static-1.5197",
  "utility-belt": "static-1.2406",
  "payments-enrollment-embed-lib": "static-1.22199",
  "customer-data-rte": "static-1.32613",
  "cv-backend-services": "static-1.1527",
  "growth-onboarding-empty-states": "static-1.5462",
  "payments-post-enroll-local-storage-lib": "static-1.4980",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37505",
  "calling-orchestration-schema": "static-1.35219",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2909",
  "interframe": "static-3.4629",
  "tinymce-data": "static-1.40023",
  "ui-addon-sales-email": "static-1.5079",
  "layout-dnd-components": "static-1.12173",
  "layout-dnd-utils": "static-1.11148",
  "ui-brand-identity-lib": "static-1.14372",
  "NamespacedHubStyle": "static-2.8957",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4397",
  "video-embed": "static-1.35278",
  "social-insights-client-types": "static-1.21590",
  "deal-intel-utils": "static-1.1513",
  "checkout-sdk": "static-3.23321",
  "checkout-service-types": "static-1.3715",
  "company-details-components": "static-1.6052",
  "payment-method-components": "static-1.6759",
  "pricing-pages-ui-components": "static-1.12982",
  "quote-checkout-service-types": "static-1.3352",
  "upgrade-catalog-service-types": "static-1.3392",
  "access-control-lib": "static-1.10304",
  "EmailComponents": "static-1.54329",
  "EmailData": "static-1.53006",
  "redux-less": "static-2.9352",
  "sequences-lib": "static-1.7800",
  "ui-gdpr-components": "static-1.10214",
  "products-ui-components": "static-1.39550",
  "quotes-ui-lib": "static-1.80136",
  "SalesContentIndexUI": "static-3.9006",
  "accounting-integrations-ui-components": "static-1.6838",
  "invoices-ui-lib": "static-1.54256",
  "commerce-products-api": "static-1.2059",
  "SafeStorage": "static-1.4268",
  "invoices-iframe-lib": "static-1.56314",
  "quotes-modal-lib": "static-1.102093",
  "stripe-embedded-components": "static-1.7257",
  "draft-content-plugins": "static-1.27880",
  "ContentData": "static-1.67906",
  "layout-data-lib": "static-1.9473",
  "outpost": "static-1.4065",
  "hub-http-rxjs": "static-1.779",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3795",
  "billing-payments-client-types": "static-1.3855",
  "account-and-billing-fintech-outages": "static-3.18327",
  "pricing-pages-api": "static-1.12847",
  "ContentComponents": "static-2.70787",
  "marketing-contacts-lib": "static-1.9353",
  "marketing-email-service-types": "static-1.1815",
  "messaging-editing-lib": "static-1.45810",
  "messaging-usage-based-billing-components-lib": "static-1.672",
  "automation-ui-source-apps": "static-1.18419",
  "automation-ui-types": "static-1.19337",
  "messaging-types-lib": "static-1.45547",
  "onboarding-settings-client": "static-1.4371",
  "sequences-client-types-lib": "static-1.7657",
  "commerce-tax-lib": "static-1.384",
  "property-description-translator": "static-1.3721",
  "FireAlarmUi": "static-1.4395",
  "sales-templates-service-types-lib": "static-1.4054",
  "commerce-analytics-service-client": "static-1.3522",
  "totals-ui-components": "static-1.23168",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14911",
  "advanced-menus-lib": "static-1.11879",
  "ui-memberships-settings-lib": "static-1.33630",
  "demographics-service-types": "static-1.1515",
  "automation-ui-ubb": "static-1.5253",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7206",
  "data-token-views": "static-1.16141",
  "forms-utils-lib": "static-1.12302",
  "payments-embed-points-lib": "static-1.12739",
  "simple-menus-core": "static-1.14910",
  "simple-menus-lib": "static-1.16427",
  "ui-addon-draggable-compat": "static-2.4120",
  "videoconference-integration-components": "static-1.6621",
  "automation-applications-service-types": "static-1.3399",
  "automation-platform-service-types": "static-1.2544",
  "ContentEditorUI": "static-2.76718",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13518",
  "web-interactives-data": "static-1.13519",
  "messaging-shared-utils-lib": "static-1.121",
  "messaging-user-info-utils-lib": "static-1.291",
  "email-portal-health-service-types": "static-1.842",
  "commerce-totals-service-types": "static-1.3703",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21273",
  "automation-ui-usage-tracking": "static-1.20736",
  "data-studio-ubb": "static-1.2296",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26603",
  "collaboration-sidebar": "static-1.57316",
  "content-management-data-lib": "static-1.5202",
  "copilot-plugins": "static-1.10684",
  "cta-picker": "static-1.36013",
  "customer-agent-discovery-components-lib": "static-1.2628",
  "editor-components": "static-1.13029",
  "editor-iframe-lib": "static-1.8209",
  "error-messaging-js": "static-1.5056",
  "FormsCommonComponents": "static-1.85455",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.61",
  "redux-request-state": "static-1.10512",
  "SharedLegalStrings": "static-1.1619",
  "smart-content-core": "static-1.42035",
  "smart-content-lib": "static-1.42688",
  "social-composer-lib": "static-1.58412",
  "structured-content-lib": "static-1.24794",
  "theme-previewer-lib": "static-1.52863",
  "tinymce-copilot": "static-1.16006",
  "xray-recommendation-lib": "static-1.7686",
  "automation-ui-routing": "static-1.20694",
  "sql-reporting-client-types": "static-1.5530",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41822",
  "campaigns-utils-lib": "static-1.3021",
  "reporting-enablement": "static-1.22327",
  "chatspot-widget-iframe": "static-1.20611",
  "collaboration-sidebar-common": "static-1.2113",
  "forms-ai-lib": "static-1.4101",
  "codemirror-dlb": "static-1.58277",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6294",
  "report-customization-components": "static-1.12710",
  "data-quality-ui-library": "static-1.12491",
  "html-to-image": "static-1.50",
  "reporting-insights-lib": "static-1.1266"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11772",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.285",
  "data-fetching-client": "/data-fetching-client/static-1.9543",
  "foundations-components": "/foundations-components/static-1.7649",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.674",
  "foundations-theming": "/foundations-theming/static-1.4278",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7874",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9644",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11309",
  "I18n": "/I18n/static-7.1594",
  "jasmine-runner": "/jasmine-runner/static-1.6336",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11833",
  "quartz": "/quartz/static-1.6818",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16516",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2729",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8739",
  "settings-ui-lib": "/settings-ui-lib/static-1.12389",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6867",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11012",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9411",
  "unified-auth": "/unified-auth/static-1.303",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.584",
  "usage-tracker": "/usage-tracker/static-1.7201",
  "usage-tracker-core": "/usage-tracker-core/static-1.7051",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7946",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6084",
  "integrations-lib": "/integrations-lib/static-1.15632",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19148",
  "property-management-iframe": "/property-management-iframe/static-1.12648",
  "quartz-config": "/quartz-config/static-1.596",
  "quartz-core": "/quartz-core/static-1.6037",
  "quartz-routing": "/quartz-routing/static-1.248",
  "quick-fetch": "/quick-fetch/static-1.3800",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4509",
  "ts-schema": "/ts-schema/static-1.3967",
  "ui-universal-auth": "/ui-universal-auth/static-1.8789",
  "UIComponents": "/UIComponents/static-3.8256",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3291",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3095",
  "quartz-webpack": "/quartz-webpack/static-1.3042",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3918",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4707",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1994",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9292",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5237",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1404",
  "ui-fonts": "/ui-fonts/static-1.571",
  "ui-images": "/ui-images/static-2.1119",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2761",
  "foundations-theming-base": "/foundations-theming-base/static-1.3263",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.728",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2985",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4192",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8553",
  "ai-rendering-library": "/ai-rendering-library/static-1.9530",
  "chirp-fetch": "/chirp-fetch/static-1.1749",
  "connections-embed-lib": "/connections-embed-lib/static-1.729",
  "copilot-toolkit": "/copilot-toolkit/static-1.10711",
  "laboratory-lib": "/laboratory-lib/static-3.7025",
  "marketplace-embed": "/marketplace-embed/static-1.21648",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9044",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19104",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13319",
  "sanitize-text": "/sanitize-text/static-1.8011",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8562",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5615",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4887",
  "wootric-nps": "/wootric-nps/static-1.6848",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4517",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4020",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2409",
  "reporting-data": "/reporting-data/static-1.66806",
  "cssUtils": "/cssUtils/static-1.759",
  "flux-actions": "/flux-actions/static-1.321",
  "HubStyle": "/HubStyle/static-2.11617",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10077",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10240",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7191",
  "icons": "/icons/static-2.635",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17681",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4386",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5132",
  "quartz-i18n": "/quartz-i18n/static-1.493",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3596",
  "customer-data-objects": "/customer-data-objects/static-1.7519",
  "property-translator": "/property-translator/static-1.5275",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7790",
  "hs-promise-utils": "/hs-promise-utils/static-1.5459",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4745",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13047",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5456",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7653",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4340",
  "superstore": "/superstore/static-1.4635",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10012",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7655",
  "hub-http-janus": "/hub-http-janus/static-1.813",
  "hubspotter-http": "/hubspotter-http/static-1.4540",
  "immutable-less": "/immutable-less/static-1.4520",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16555",
  "nav-meta": "/nav-meta/static-1.29136",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10108",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17759",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3733",
  "property-management-common": "/property-management-common/static-1.4936",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8913",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.503",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.493",
  "quartz-head": "/quartz-head/static-1.483",
  "quartz-test": "/quartz-test/static-1.493",
  "quartz-tracking": "/quartz-tracking/static-1.197",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3022",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20619",
  "ContentUtils": "/ContentUtils/static-1.67831",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2358",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39150",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12879",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13015",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13791",
  "ExportDialog": "/ExportDialog/static-6.10255",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40836",
  "reporting-snowflake": "/reporting-snowflake/static-1.55424",
  "reporting-ui-components": "/reporting-ui-components/static-2.64077",
  "reporting-visualizations": "/reporting-visualizations/static-1.58882",
  "ui-addon-teams": "/ui-addon-teams/static-1.21337",
  "magpie-lib": "/magpie-lib/static-1.5460",
  "magpie-types": "/magpie-types/static-1.4920",
  "simple-logging-lib": "/simple-logging-lib/static-1.2916",
  "navigation-components": "/navigation-components/static-1.17499",
  "ai-studio-lib": "/ai-studio-lib/static-1.11183",
  "app-governance-lib": "/app-governance-lib/static-1.1088",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10368",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7857",
  "ui-product-approvals": "/ui-product-approvals/static-1.27679",
  "ui-tool-access": "/ui-tool-access/static-1.10011",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8197",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5618",
  "usage-tracker-public": "/usage-tracker-public/static-1.7012",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3482",
  "persist-promise": "/persist-promise/static-1.3574",
  "reference-resolvers": "/reference-resolvers/static-1.8031",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3807",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.204",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2867",
  "final-form": "/final-form/static-1.66",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2366",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4936",
  "purchase-motions-components": "/purchase-motions-components/static-1.5592",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1417",
  "crm-component-utils": "/crm-component-utils/static-1.38647",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5739",
  "customer-data-properties": "/customer-data-properties/static-1.51001",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6739",
  "property-value-citations": "/property-value-citations/static-1.1615",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7951",
  "navigation-messaging": "/navigation-messaging/static-1.6826",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9642",
  "cms-field-types": "/cms-field-types/static-1.4675",
  "content-icons-ui": "/content-icons-ui/static-1.2183",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7115",
  "crm-message-bus": "/crm-message-bus/static-1.42568",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21585",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9690",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4587",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3895",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6644",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.843",
  "onboarding-tours": "/onboarding-tours/static-1.16354",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13252",
  "academy-common-lib": "/academy-common-lib/static-1.13251",
  "content-assistance-lib": "/content-assistance-lib/static-1.7541",
  "dashboard-lib": "/dashboard-lib/static-1.80906",
  "file-manager-components": "/file-manager-components/static-1.23124",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18069",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17801",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17793",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19588",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8559",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4634",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10805",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8899",
  "user-context": "/user-context/static-1.4966",
  "growth-payments-core": "/growth-payments-core/static-1.24916",
  "reporting-plugins": "/reporting-plugins/static-1.10064",
  "reporting-reports": "/reporting-reports/static-1.66484",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.591",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.29007",
  "react-codemirror": "/react-codemirror/static-1.10492",
  "framework-listing-lib": "/framework-listing-lib/static-2.28227",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30291",
  "apps-service-types": "/apps-service-types/static-1.3743",
  "oauth-service-types": "/oauth-service-types/static-1.4113",
  "onboarding-scopes": "/onboarding-scopes/static-1.6329",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4568",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7554",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14673",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3504",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8773",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4365",
  "nav-client-types": "/nav-client-types/static-1.2223",
  "purchase-motions-api": "/purchase-motions-api/static-1.5595",
  "signup-constants": "/signup-constants/static-1.18544",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7901",
  "trials-service-types": "/trials-service-types/static-1.3766",
  "card-properties-lib": "/card-properties-lib/static-1.43715",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36651",
  "crm-actions": "/crm-actions/static-1.6176",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43120",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8971",
  "customer-data-tracking": "/customer-data-tracking/static-1.6748",
  "hs-entities": "/hs-entities/static-1.553",
  "pulse": "/pulse/static-1.390",
  "calling-global-api": "/calling-global-api/static-1.63935",
  "calling-internal-common": "/calling-internal-common/static-1.31166",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65317",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57611",
  "commerce-products-lib": "/commerce-products-lib/static-1.9031",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3685",
  "crm-links": "/crm-links/static-1.6135",
  "external-options-client-types": "/external-options-client-types/static-1.4046",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4110",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.498",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3577",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48230",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3851",
  "smart-property-lib": "/smart-property-lib/static-1.6201",
  "tiered-pricing": "/tiered-pricing/static-1.934",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10859",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4027",
  "react-dnd-compat": "/react-dnd-compat/static-1.4486",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5225",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2938",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1475",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.420",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7393",
  "academy-service-client": "/academy-service-client/static-1.3546",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28123",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8250",
  "video-components-external": "/video-components-external/static-1.10786",
  "video-data-lib": "/video-data-lib/static-1.34444",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8424",
  "payment-link-components": "/payment-link-components/static-1.23115",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9753",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24036",
  "viral-links-lib": "/viral-links-lib/static-1.6906",
  "data-token-picker": "/data-token-picker/static-1.16160",
  "FileManagerLib": "/FileManagerLib/static-1.38764",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5110",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17187",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8483",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7188",
  "customer-data-views-management": "/customer-data-views-management/static-1.25125",
  "framework-data-table": "/framework-data-table/static-2.11582",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6711",
  "nudge-client-utils": "/nudge-client-utils/static-1.2286",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.790",
  "app-users-service-client": "/app-users-service-client/static-1.5410",
  "app-users-service-types": "/app-users-service-types/static-1.4818",
  "mini-checkout-client": "/mini-checkout-client/static-1.26478",
  "onboarding-utils": "/onboarding-utils/static-1.5218",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28108",
  "edison-service-client-types": "/edison-service-client-types/static-1.258",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3047",
  "crm_data": "/crm_data/static-4.91472",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45597",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15319",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18676",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18135",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9969",
  "crm-fe-perf": "/crm-fe-perf/static-1.22770",
  "directed-graph": "/directed-graph/static-1.805",
  "event-emitter": "/event-emitter/static-1.813",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31172",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10905",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6407",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.442",
  "commerce-permissions": "/commerce-permissions/static-1.629",
  "products-iframe-lib": "/products-iframe-lib/static-1.7519",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10026",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5415",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9727",
  "policy-lib": "/policy-lib/static-1.6644",
  "react-tinymce": "/react-tinymce/static-1.54812",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9790",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53938",
  "tinymce-plugins": "/tinymce-plugins/static-1.57052",
  "tinymce-themes": "/tinymce-themes/static-1.55908",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1503",
  "user-context-client": "/user-context-client/static-1.4479",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6447",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11727",
  "content-media-compositions": "/content-media-compositions/static-2.15734",
  "media-bridge-lib": "/media-bridge-lib/static-1.18682",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5826",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4952",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3534",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21426",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3709",
  "audio-components": "/audio-components/static-1.5705",
  "FileManagerCore": "/FileManagerCore/static-1.38623",
  "FileManagerImages": "/FileManagerImages/static-1.36275",
  "video-components": "/video-components/static-1.12789",
  "crm-export-dialog": "/crm-export-dialog/static-1.6160",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6301",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1509",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2043",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2362",
  "whisper-core-api": "/whisper-core-api/static-1.6173",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14402",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5207",
  "settings-content-modals": "/settings-content-modals/static-1.45652",
  "crm_universal": "/crm_universal/static-1.21762",
  "customer-data-email": "/customer-data-email/static-1.17787",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36704",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39074",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11449",
  "customer-data-content": "/customer-data-content/static-1.27002",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54240",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21044",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17315",
  "project-storage": "/project-storage/static-1.4599",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71415",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5197",
  "utility-belt": "/utility-belt/static-1.2406",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22199",
  "customer-data-rte": "/customer-data-rte/static-1.32613",
  "cv-backend-services": "/cv-backend-services/static-1.1527",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5462",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4980",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37505",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35219",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2909",
  "interframe": "/interframe/static-3.4629",
  "tinymce-data": "/tinymce-data/static-1.40023",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5079",
  "layout-dnd-components": "/layout-dnd-components/static-1.12173",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11148",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14372",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8957",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4397",
  "video-embed": "/video-embed/static-1.35278",
  "social-insights-client-types": "/social-insights-client-types/static-1.21590",
  "deal-intel-utils": "/deal-intel-utils/static-1.1513",
  "checkout-sdk": "/checkout-sdk/static-3.23321",
  "checkout-service-types": "/checkout-service-types/static-1.3715",
  "company-details-components": "/company-details-components/static-1.6052",
  "payment-method-components": "/payment-method-components/static-1.6759",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.12982",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3352",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3392",
  "access-control-lib": "/access-control-lib/static-1.10304",
  "EmailComponents": "/EmailComponents/static-1.54329",
  "EmailData": "/EmailData/static-1.53006",
  "redux-less": "/redux-less/static-2.9352",
  "sequences-lib": "/sequences-lib/static-1.7800",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10214",
  "products-ui-components": "/products-ui-components/static-1.39550",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80136",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9006",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6838",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54256",
  "commerce-products-api": "/commerce-products-api/static-1.2059",
  "SafeStorage": "/SafeStorage/static-1.4268",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56314",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102093",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7257",
  "draft-content-plugins": "/draft-content-plugins/static-1.27880",
  "ContentData": "/ContentData/static-1.67906",
  "layout-data-lib": "/layout-data-lib/static-1.9473",
  "outpost": "/outpost/static-1.4065",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.779",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3795",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3855",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18327",
  "pricing-pages-api": "/pricing-pages-api/static-1.12847",
  "ContentComponents": "/ContentComponents/static-2.70787",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9353",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1815",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45810",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.672",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18419",
  "automation-ui-types": "/automation-ui-types/static-1.19337",
  "messaging-types-lib": "/messaging-types-lib/static-1.45547",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4371",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7657",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.384",
  "property-description-translator": "/property-description-translator/static-1.3721",
  "FireAlarmUi": "/FireAlarmUi/static-1.4395",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4054",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3522",
  "totals-ui-components": "/totals-ui-components/static-1.23168",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14911",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11879",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33630",
  "demographics-service-types": "/demographics-service-types/static-1.1515",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5253",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7206",
  "data-token-views": "/data-token-views/static-1.16141",
  "forms-utils-lib": "/forms-utils-lib/static-1.12302",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12739",
  "simple-menus-core": "/simple-menus-core/static-1.14910",
  "simple-menus-lib": "/simple-menus-lib/static-1.16427",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4120",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6621",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3399",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
  "ContentEditorUI": "/ContentEditorUI/static-2.76718",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13518",
  "web-interactives-data": "/web-interactives-data/static-1.13519",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.121",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.291",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.842",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3703",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21273",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20736",
  "data-studio-ubb": "/data-studio-ubb/static-1.2296",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26603",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57316",
  "content-management-data-lib": "/content-management-data-lib/static-1.5202",
  "copilot-plugins": "/copilot-plugins/static-1.10684",
  "cta-picker": "/cta-picker/static-1.36013",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2628",
  "editor-components": "/editor-components/static-1.13029",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8209",
  "error-messaging-js": "/error-messaging-js/static-1.5056",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85455",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.61",
  "redux-request-state": "/redux-request-state/static-1.10512",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1619",
  "smart-content-core": "/smart-content-core/static-1.42035",
  "smart-content-lib": "/smart-content-lib/static-1.42688",
  "social-composer-lib": "/social-composer-lib/static-1.58412",
  "structured-content-lib": "/structured-content-lib/static-1.24794",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52863",
  "tinymce-copilot": "/tinymce-copilot/static-1.16006",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7686",
  "automation-ui-routing": "/automation-ui-routing/static-1.20694",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5530",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41822",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3021",
  "reporting-enablement": "/reporting-enablement/static-1.22327",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20611",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2113",
  "forms-ai-lib": "/forms-ai-lib/static-1.4101",
  "codemirror-dlb": "/codemirror-dlb/static-1.58277",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6294",
  "report-customization-components": "/report-customization-components/static-1.12710",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12491",
  "html-to-image": "/html-to-image/static-1.50",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1266"
}
};
